// Adapter: chuyển .docx → HTML phía client (dùng mammoth đã cài sẵn).
// Tái dùng thư viện có sẵn, KHÔNG sửa WordToJsonConverter gốc.
// Chạy hoàn toàn trong trình duyệt — không cần backend (ảnh nhúng → base64).

let cachedMammoth: any = null

async function getMammoth(): Promise<any> {
  if (cachedMammoth) return cachedMammoth
  // Ưu tiên bản đã nạp trên window (nếu app đã nạp qua CDN ở nơi khác)
  if (typeof window !== 'undefined' && (window as any).mammoth) {
    cachedMammoth = (window as any).mammoth
    return cachedMammoth
  }
  // Nạp động từ gói npm (code-splitting, an toàn với Vite)
  const mod: any = await import('mammoth')
  cachedMammoth = mod?.default || mod
  return cachedMammoth
}

export interface DocxImportResult {
  html: string
  warnings: string[]
}

export async function convertDocxToHtml(file: File): Promise<DocxImportResult> {
  const mammoth = await getMammoth()
  const arrayBuffer = await file.arrayBuffer()
  const result = await mammoth.convertToHtml(
    { arrayBuffer },
    {
      styleMap: [
        "p[style-name='Heading 1'] => h1:fresh",
        "p[style-name='Heading 2'] => h2:fresh",
        "p[style-name='Heading 3'] => h3:fresh",
        "p[style-name='List Paragraph'] => p:fresh",
      ],
    }
  )
  return {
    html: result?.value || '',
    warnings: (result?.messages || []).map((m: any) => m.message || String(m)),
  }
}
